import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=9965595a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=9965595a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965595a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9965595a')) {
      api.createRecord('9965595a', component.options)
    } else {
      api.reload('9965595a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=9965595a&scoped=true&", function () {
      api.rerender('9965595a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8v8mtGChIa9zX/JS/comp/PopupDialog.vue"
export default component.exports